// extracted by mini-css-extract-plugin
export default {"header":"zrRLW7GL2w6xOBK_ey4N","close":"nFUvpyVg63Wbumneaflq","idTypes":"AQ9aVcgPyEnnPlB5xT9B","dot":"Q_BjbPayrmrbj6YM5tdq"};